import * as React from 'react';

import {
    FlexColumn,
    H2,
    PageBody,
    PageBodyFooter,
    PageContainer,
    PageHeader,
} from '@portal/common/components';

import _ from '../../locale';
import DataLicenseView from './DataLicenseView';

const DataLicenseScene = () => (
    <PageContainer>
        <PageHeader>
            <H2>{_.get('data_license_title')}</H2>
        </PageHeader>
        <PageBody>
            <FlexColumn grow={1}>
                <DataLicenseView />
            </FlexColumn>
            <PageBodyFooter>{_.get('footer_note')}</PageBodyFooter>
        </PageBody>
    </PageContainer>
);

export default DataLicenseScene;
